import React from 'react';
import { Link } from 'react-router-dom';
import allItems from '../data/index';

const categories = {
  none: {
    bannerName: 'combo-banner-2.png'
  },
  ['Balsam Pillows']: {
    bannerName: 'bp-banner.png'
  },
  ['In Situ']: {
    bannerName: 'combo-banner-2.png'
  },
  ['Patch Pillows']: {
    bannerName: 'pp-banner.png'
  },
  ['Bed Quilts']: {
    bannerName: 'Q-banner-2.png',
  },
  ['Framed Hangings']: {
    bannerName: 'h-banner.jpg'
  },
  ['Wall Hangings']: {
    bannerName: 'h-banner.jpg',
  },
}


function Gallery() {
  const [category, setCategory] = React.useState('none');

  const categoryDetails = categories[category];

  return (
    <div className="gallery">
      <div className="gallery__header">
        <div className="gallery__header_text_container">
          <h1 className="gallery__header-title">Gallery</h1>
        </div>
        <img src={process.env.PUBLIC_URL + `/assets/images/banners/${categoryDetails.bannerName}`} alt="Gallery Header" />
      </div>
      <div className="gallery__categories">
        {Array.from(new Set(allItems.map(item => item.category))).map((c) => (
          <button key={c} className={`gallery__category-button${category === c ? '--active' : ''}`} onClick={() => setCategory((prev) => prev === c ? 'none' : c)}>
            {c}
          </button>
        ))}
      </div>
      <div className="gallery__grid">
        {allItems.filter(item => category ==='none' || item.category === category).map((item, index) => (
          <Link to={`/gallery/${item.id}`} key={index} className="gallery__item">
            <img
              src={process.env.PUBLIC_URL + item.image}
              alt={item.title}
              className="gallery__image"
            />
            <div className="gallery__details">
              <div className="gallery__category">{item.category}</div>
              <h3 className="gallery__title">{item.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
